import { render, staticRenderFns } from "./PracticeInlandVesselDetailsContent.vue?vue&type=template&id=5b5fa2e7"
import script from "./PracticeInlandVesselDetailsContent.vue?vue&type=script&lang=ts"
export * from "./PracticeInlandVesselDetailsContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports